export enum NoteTypeOption {
  NOTE = 'note',
  TODO = 'todo',
  OPEN_TODO = 'open_todo',
  MENTIONS = 'mentions',
}

export const UNTAGGED_FILTER = 'untagged'
